import DurationTypeProvider  from './DurationTypeProvider'

export default DurationTypeProvider
